var $bff5b1e7d0cba852$exports = {};
const $bff5b1e7d0cba852$var$url = "https://pizzaapi-kzs1.onrender.com/booking" //URL till mitt API
;
const $bff5b1e7d0cba852$var$bookingFormEl = document.getElementById("bookingForm");
/* funktion för att läsa in datan i formuläret */ const $bff5b1e7d0cba852$var$bookBtnEl = document.getElementById("bookBtn");
$bff5b1e7d0cba852$var$bookBtnEl.addEventListener("click", (e)=>{
    e.preventDefault();
    let name = document.getElementById("booking-name").value;
    let phonenumber = document.getElementById("booking-phone").value;
    let numberOfGuests = document.getElementById("booking-amount").value;
    let date = document.getElementById("booking-date").value;
    $bff5b1e7d0cba852$var$createBooking(name, phonenumber, numberOfGuests, date);
});
/* Funktion för att lägga till bokningar i databasen */ async function $bff5b1e7d0cba852$var$createBooking(name, phonenumber, numberOfGuests, date) {
    let booking = {
        name: name,
        phonenumber: phonenumber,
        numberOfGuests: numberOfGuests,
        date: date
    };
    let bookingStatus = document.getElementById("bookingStatus");
    const response = await fetch($bff5b1e7d0cba852$var$url + "/", {
        method: "POST",
        headers: {
            "Content-Type": "Application/json"
        },
        body: JSON.stringify(booking)
    });
    const data = await response.json();
    console.log(data);
    if (data.error) bookingStatus.innerHTML = `${data.error}`;
    else {
        bookingStatus.innerHTML = `${data.message} <i class="fa-solid fa-check"></i>`;
        $bff5b1e7d0cba852$var$bookBtnEl.disabled = true;
        $bff5b1e7d0cba852$var$bookBtnEl.classList.add("disabled");
    }
}


//# sourceMappingURL=index.89170a3c.js.map
